import { bool, object } from 'yup';

export const ReferralCancelOptionsSchema = object().shape({
  emails: object().shape({
    skipEmailToReferrerUnableToProceed: bool(),
    skipEmailToClientNoBooking: bool(),
  }),
});
